import React, {Component} from 'react';
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import CustomerWarningForm from "./CustomerWarningForm";
import {deepCopyObject} from "../../../helper/helper";
import Alert from "react-s-alert";

class CustomerWarningEditModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			disabled: true,
			newWarningType: null,
			newWarningOption: null,
			newWarningMail: null,
			newWarningPhone: null
		};

		this.submitNewWarning = this.submitNewWarning.bind(this);
		this.setWarningTypesDropdownListSize = this.setWarningTypesDropdownListSize.bind(this);
		this.setNewWarningType = this.setNewWarningType.bind(this);
		this.setNewWarningOption = this.setNewWarningOption.bind(this);
		this.setNewWarningMail = this.setNewWarningMail.bind(this);
		this.setNewWarningPhone = this.setNewWarningPhone.bind(this);
		this.captureObject = this.captureObject.bind(this);
	}

	closeModal() {
		this.props.closeModal();
	}

	submitNewWarning() {
		this.props.submitNewWarning();
	}

	switchModeToList() {
		this.props.switchModeToList();
	}

	setWarningTypesDropdownListSize() {
		this.props.setWarningTypesDropdownListSize();
	}

	removeWarning() {
		let index = this.props.selectedIndex;
		this.props.onRemoveWarning(null, index);
	}

	setNewWarningType(value) {
		this.setState({
			newWarningType: value
		}, () => {
			this.isSubmitButtonDisabled();
		})
	}

	setNewWarningOption(value) {
		this.setState({
			newWarningOption: value
		}, () => {
			this.isSubmitButtonDisabled();
		})
	}

	setNewWarningMail(value) {
		this.setState({
			newWarningMail: value
		}, () => {
			this.isSubmitButtonDisabled();
		})
	}

	setNewWarningPhone(value) {
		this.setState({
			newWarningPhone: value
		}, () => {
			this.isSubmitButtonDisabled();
		})
	}

	isSubmitButtonDisabled() {

		let disabled;

		let newWarningType = this.state.newWarningType;
		let newWarningOption = this.state.newWarningOption;
		let newWarningMail = this.state.newWarningMail;
		let newWarningPhone = this.state.newWarningPhone;

		let warningType = this.props.selectedWarning.warningType.recordId;
		let warningOption = this.props.selectedWarning.warningOption.recordId;
		let warningMail = this.props.selectedWarning.warningMail;
		let warningPhone = this.props.selectedWarning.warningPhone;

		if (!!newWarningType || !!newWarningOption || !!newWarningMail || !!newWarningPhone) {
			if ((!!newWarningType && (warningType !== newWarningType)) || (!!newWarningOption && (warningOption !== newWarningOption)) ||
				(!!newWarningMail && (warningMail !== newWarningMail)) || (!!newWarningPhone && (warningPhone !== newWarningPhone))) {

				disabled = false;
			} else {
				disabled = true;
			}
		} else {
			disabled = true;
		}

		this.setState({
			disabled
		})
	}

	async updateCurrentWarning() {

		await document.getElementById('childObjectPicker').click();
		let childValidationResponse = this.state.childValidationResponse;

		if (childValidationResponse.valid) {
			let updatedWarning = {};

			updatedWarning.warningType = this.state.newWarningType;
			updatedWarning.warningOption = this.state.newWarningOption;
			updatedWarning.warningMail = this.state.newWarningMail;
			updatedWarning.warningPhone = this.state.newWarningPhone;

			updatedWarning.selectedIndex = this.props.selectedIndex;



			this.props.updateWarningAndCurrentWarnings(updatedWarning);

			this.setState({
				disabled: true,
				newWarningType: null,
				newWarningOption: null,
				newWarningMail: null,
				newWarningPhone: null
			})
		} else {
			Alert.error(this.arrangeErrorMessage(), {
				position: 'top-right',
				effect: 'stackslide',
				html: true,
				timeout: 5000
			});
		}
	}

	arrangeErrorMessage() {
		let errorObject = deepCopyObject(this.state.childValidationResponse.error);

		let errorArray = [];

		for (let key in errorObject) {
			if (errorObject.hasOwnProperty(key)) {
				let error = {};
				if (!!errorObject[key].message) {
					error.field = this.defineReadableFieldName(key);
					error.message = errorObject[key].message;
					errorArray.push(error);
				}
			}
		}

		this.setState({error: errorObject});

		return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/>').join('')
	}

	defineReadableFieldName(key) {

		switch (key) {
			case 'tEmail':
				return 'e-Posta Adresi: ';
			case 'tPhone':
				return 'Telefon Numarası: ';
			default :
				return '';
		}
	}

	onCancelEditWarning() {

		this.setState({
			disabled: true,
			newWarningType: null,
			newWarningOption: null,
			newWarningMail: null,
			newWarningPhone: null
		});

		this.props.closeModal();
	}

	captureObject(obj) {
		let childValidationResponse = deepCopyObject(obj);
		this.setState({
			childValidationResponse
		})
	}

	render() {

		const customerWarnings = this.props.currentWarnings && this.props.currentWarnings;

		return (
			<Modal isOpen={this.props.mode === 'edit'} size='lg'>
				<ModalHeader toggle={() => this.closeModal()}>
					Bildirimi Düzenle
				</ModalHeader>
				<ModalBody>
					<CustomerWarningForm currentWarnings={customerWarnings} warningTypes={this.props.warningTypes} warningOptions={this.props.warningOptions}
										 mode={this.props.mode} switchModeToList={this.switchModeToList} submitNewWarning={this.submitNewWarning}
										 setWarningTypesDropdownListSize={this.setWarningTypesDropdownListSize} selectedWarning={this.props.selectedWarning}
										 setNewWarningType={this.setNewWarningType} setNewWarningOption={this.setNewWarningOption}
										 setNewWarningMail={this.setNewWarningMail} setNewWarningPhone={this.setNewWarningPhone}
										 captureObject={this.captureObject}/>
				</ModalBody>
				<ModalFooter>
					<Col sm='2'/>
					<Col sm='8' style={{textAlign: 'center', padding: '0'}}>
						<Row>
							<Col sm='4' style={{textAlign: 'center', padding: '0', margin: '0'}}>
								<button type="button" class="textButton cancel" onClick={() => this.onCancelEditWarning()}>İptal</button>
							</Col>
							<Col sm='8' style={{textAlign: 'center', padding: '0', margin: '0'}}>
								<button type="button" class="textButton remove" style={{margin: '0 2% 0 2%'}} onClick={() => this.removeWarning()}>Kaldır
								</button>
								<button type="button" class="textButton confirm" style={{margin: '0 2% 0 2%'}} disabled={this.state.disabled}
										onClick={() => this.updateCurrentWarning()}>Kaydet
								</button>
							</Col>
						</Row>
					</Col>
					<Col sm='2'/>
				</ModalFooter>
			</Modal>
		)
	}
}

export default CustomerWarningEditModal;